import { Hub } from 'react-signalr/lib/signalr/types';
import { AssessmentSessionProcessTypeId } from '../services/exams/assessmentSession/assessments.types';
import { Folder, Message, UserSigningInfoMessage } from './communication.types';
import { Notification } from './notification.types';
import { BlockadeTypeId } from './../components/ExaminersStructure/ExaminersStructure.types';

export enum ServerOperations {
  SendToServer = 'SendToServer',
  JoinedAssessmentSession = 'JoinedAssessmentSession',
  LeftAssessmentSession = 'LeftAssessmentSession',
  ReceivedNewMessage = 'ReceivedNewMessage',
  NewPushNotification = 'NewPushNotification',
  NewProcedureNotification = 'NewProcedureNotification',
  ExaminerBlocked = 'ExaminerBlocked',
  ExaminerUnblocked = 'ExaminerUnblocked',
  UserSigningInfo = 'UserSigningInfo',
  DeleteTasksSolutionSheetsMessage = 'DeleteTasksSolutionSheetsMessage',
  UserDeletedInfo = "UserDeletedInfo"
}

export type Operations = {
  [ServerOperations.SendToServer]: (message: string) => Promise<void>;
  [ServerOperations.JoinedAssessmentSession]: (assessmentSessionId: string) => Promise<void>;
  [ServerOperations.LeftAssessmentSession]: (assessmentSessionId: string) => Promise<void>;
  [ServerOperations.ReceivedNewMessage]: (message: Message, folder: Folder) => Promise<void>;
  [ServerOperations.NewPushNotification]: (notification: Notification) => Promise<void>;
  [ServerOperations.NewProcedureNotification]: (notification: Notification) => Promise<void>;
  [ServerOperations.ExaminerBlocked]: (message: BlockadeMessage) => Promise<void>;
  [ServerOperations.ExaminerUnblocked]: (message: BlockadeMessage) => Promise<void>;
  [ServerOperations.UserSigningInfo]: (message: UserSigningInfoMessage) => Promise<void>;
  [ServerOperations.DeleteTasksSolutionSheetsMessage]: (notification: Notification) => Promise<void>;
  [ServerOperations.UserDeletedInfo] : (notification : UserDeleteNotificationInfo) => Promise<void>;
};

export enum CallbackMethodNames {
  SendFromServer = 'SendFromServer',
  ExaminerCurrentProcessCompleted = 'ExaminerCurrentProcessCompleted',
  AssessmentSessionSuspended = 'AssessmentSessionSuspended',
  ReceivedNewMessage = 'ReceivedNewMessage',
  NewPushNotification = 'NewPushNotification',
  NewProcedureNotification = 'NewProcedureNotification',
  ExaminerBlocked = 'ExaminerBlocked',
  ExaminerUnblocked = 'ExaminerUnblocked',
  UserSigningInfo = 'UserSigningInfo',
  DeleteTasksSolutionSheetsMessage = 'DeleteTasksSolutionSheetsMessage',
  UserDeletedInfo = "UserDeletedInfo",
  StartDeleteExamineesInfo = "StartDeleteExamineesInfo",
  DeleteExamineesFinishedInfo = "DeleteExamineesFinishedInfo"
}

export type Callbacks = {
  [CallbackMethodNames.SendFromServer]: (message: string) => void;
  [CallbackMethodNames.ExaminerCurrentProcessCompleted]: (message: ExaminerProcessCompleted) => void;
  [CallbackMethodNames.AssessmentSessionSuspended]: (message: { assessmentSessionId: string }) => void;
  [CallbackMethodNames.ReceivedNewMessage]: (message: { message: Message; folder: Folder }) => void;
  [CallbackMethodNames.NewPushNotification]: (message: { notification: Notification }) => void;
  [CallbackMethodNames.NewProcedureNotification]: (message: { notification: Notification }) => void;
  [CallbackMethodNames.ExaminerBlocked]: (message: BlockadeMessage) => void;
  [CallbackMethodNames.ExaminerUnblocked]: (message: BlockadeMessage) => void;
  [CallbackMethodNames.DeleteTasksSolutionSheetsMessage]: (message: Notification ) => void;
  [CallbackMethodNames.UserSigningInfo]: (message: UserSigningInfoMessage ) => void;
  [CallbackMethodNames.UserDeletedInfo]: (message:UserDeleteNotificationInfo ) => void;
  [CallbackMethodNames.StartDeleteExamineesInfo]: (message:StartDeleteExamineesNotificationInfoDto) => void;
  [CallbackMethodNames.DeleteExamineesFinishedInfo]: (message:DeleteExamineesFinishedMessage) => void;
};

export interface ExaminerProcessCompleted {
  succeeded: boolean;
  nextProcess?: AssessmentSessionProcessTypeId;
}

export interface OneSignalR extends Hub {
  methodsName: ServerOperations;
  methods: Operations;

  callbacksName: CallbackMethodNames;
  callbacks: Callbacks;
}

export interface BlockadeMessage {
  assessmentSessionId: string;
  examinerPermissionId: string;
  blockadeTypeId?: BlockadeTypeId;
}
export interface UserDeleteNotificationInfo{
  firstName: string;
  lastName: string;
  succeeded: boolean;
}
export interface StartDeleteExamineesNotificationInfoDto {
  examineesToDeleteCount: number;
}
export interface DeleteExamineesFinishedMessage {
  Id: string;
  successed: boolean;
  DeletedCount: number;
  TotalCount: number;
}
